// eslint-disable-next-line no-shadow
export enum DATE_FORMAT {
  ES = 'DD/MM/YYYY',
  EN = 'MM/DD/YYYY'
}

export const getDefaultDateFormat = () => DATE_FORMAT.ES;
